module.exports = __webpack_public_path__ + "static/media/32.26b14b68.jpg";